var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    !_vm.type
      ? _c("p", { staticClass: "alert alert-info" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" " + _vm._s(_vm.trans(_vm.module + "." + _vm.tip)))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type
      ? _c("i", {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.trans(_vm.module + "." + _vm.tip),
              expression: "trans(module+'.'+tip)"
            }
          ],
          staticClass: "fas fa-info-circle float-right"
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63afa4d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63afa4d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/show-tip.vue
// module id = 456
// module chunks = 376